"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkMovePermissions = exports.checkCopyPermissions = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/folders/permissionChecks");
const Actions = require("../../actions/folders/permissionChecks");
const TypesLib = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
function checkCopyPermissions(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.CHECK_COPY_REQUEST).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/files/${payload.folderUuid}/READABLE?includeRevisions=false&includeSubFolders=false&includePath=true`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        response = response.filter((f) => f.uuid !== payload.folderUuid);
        const fols = response;
        const data = {
            rootId: NaN,
            rootIdentifier: payload.folderUuid
        };
        const folders = fols.map((f) => ({
            id: f.id,
            name: f.name,
            identifier: f.uuid,
            parentId: f.parent,
            parentIdentifier: f.parentUuid,
            childrenCount: f.length,
            permissions: ['READABLE']
        }));
        Object.assign(data, { folders: folders });
        const validate = TypesLib.File.iFolderContent.decode(data);
        const act = validate.fold((e) => Actions.checkCopyFailed((0, errorHandling_1.parseValidationError)(e), payload.folderUuid), (content) => {
            return Actions.checkCopySuccess(content);
        });
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.checkCopyFailed((0, errorHandling_1.parseAjaxErrorResponse)(error), payload.folderUuid))))));
}
exports.checkCopyPermissions = checkCopyPermissions;
function checkMovePermissions(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.CHECK_MOVE_REQUEST).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/project/${payload.projectId}/files/folders-check-move`,
        body: {
            folderUuids: payload.folderUuid
        }
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .intersection([
            t.interface({
                success: t.boolean
            }),
            t.partial({
                resources: t.array(TypesLib.File.iRevisionOrFolder)
            })
        ])
            .decode(response);
        const act = validation.fold((err) => [Actions.checkMoveFailed((0, errorHandling_1.parseValidationError)(err))], (res) => {
            if (res.success && res.resources) {
                return [Actions.checkMoveSuccess(res.success, res.resources)];
            }
            return [Actions.checkMoveSuccess(res.success, [], [])];
        });
        return (0, rxjs_1.of)(...act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.checkMoveFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.checkMovePermissions = checkMovePermissions;
//# sourceMappingURL=permissionChecks.js.map